import GuaranteedInheritance from './GuaranteedInheritance';
export { GuaranteedInheritance };



// WEBPACK FOOTER //
// ./src/containers/GuaranteedInheritance/index.js